import { useReducedMotion } from "motion/react";
import { useEffect, useState } from "react";

/**
 * SSR-safe wrapper around motion's `useReducedMotion`.
 *
 * `useReducedMotion()` reads `matchMedia` synchronously on the client's first
 * render, so a visitor with reduced motion enabled resolves a different value
 * than the server (which always sees `null`). Components that branch their
 * `initial` animation state on that value then hydrate with mismatched markup.
 *
 * Deferring to a mounted effect keeps the server and first client render in
 * agreement (no reduction), then applies the real preference after hydration.
 *
 * Aliases: reduced motion, prefers-reduced-motion, ssr-safe, hydration mismatch
 */
export function useReducedMotionSafe(): boolean {
  const prefersReducedMotion = useReducedMotion();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted ? Boolean(prefersReducedMotion) : false;
}
